import { render, staticRenderFns } from "./loading-bar.vue?vue&type=template&id=5988c915&scoped=true"
import script from "./loading-bar.vue?vue&type=script&lang=ts"
export * from "./loading-bar.vue?vue&type=script&lang=ts"
import style0 from "./loading-bar.vue?vue&type=style&index=0&id=5988c915&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5988c915",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5988c915')) {
      api.createRecord('5988c915', component.options)
    } else {
      api.reload('5988c915', component.options)
    }
    module.hot.accept("./loading-bar.vue?vue&type=template&id=5988c915&scoped=true", function () {
      api.rerender('5988c915', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loading-bar/loading-bar.vue"
export default component.exports